import slugify from 'slugify'

const ataCodes = [385, 397, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 424, 427, 428, 429, 430, 398, 415, 416, 417, 425, 399, 418, 419, 420, 421, 422, 423, 426, 431]

const isCarta = (doc) => doc.documentTypeId === 394
const isInformativo = (doc) => doc.documentTypeId === 392
const isLivro = (doc) => doc.documentTypeId === 380
const isJornal = (doc) => doc.documentTypeId === 379
const isInternet = (doc) => doc.documentTypeId === 391

export const coreSedeGeral = 1
export const regionSedeGeral = 1
export const agencySedeGeral = 1
export const agencyDiretoriageral = 2
export const agencyRegion = 3
export const agencyCoreDAV = 4
export const agencyLocal = 265

export const isBoletim = (doc) => doc.documentTypeId === 382
export const hasDocType = (doc) => Boolean(doc.documentTypeId)
export const hasLink = (doc) => isInternet(doc) || isCarta(doc) || isInformativo(doc) || isLivro(doc) || isJornal(doc)
export const hasSubType = (doc) => isCarta(doc) || isBoletim(doc) || isLivro(doc) || isInformativo(doc)

export const definedClassWithNumeration = (doc) => {
  if (isBoletim(doc)) return 'col-sm-4'
  return hasNumeration(doc) ? 'col-sm-8' : 'col-sm-12'
}

export const hasNumeration = (doc) => isCarta(doc) || isBoletim(doc)
export const hasDescription = (doc) => hasDocType(doc) && !isBoletim(doc)

export const isBoletimDesignacao = (doc) => isBoletim(doc) && doc.documentSubTypeId === 3821
export const isAgencyRegion = (doc) => [agencyLocal, agencyCoreDAV, agencyRegion].includes(doc.agencyId)
export const isAgencyCoreDav = (doc) => [agencyLocal, agencyCoreDAV].includes(doc.agencyId)
export const isAgencySGDG = (doc) => [agencySedeGeral, agencyDiretoriageral].includes(doc.agencyId)

export const definedLabelSubType = (doc) => {
  if (isCarta(doc)) return 'Tipo da Carta'
  if (isBoletim(doc)) return 'Tipo do Boletim'
  if (isLivro(doc)) return 'Tipo do Livro'
  if (isInformativo(doc)) return 'Tipo do Informativo'
  return 'Tipo'
}

export const definedLabelNumeration = (doc) => {
  if (isCarta(doc)) return 'Número da Carta'
  if (isBoletim(doc)) return 'Número do Boletim'
  return 'Número'
}

export const definedLabelDescription = (doc) => {
  if (ataCodes.includes(doc.documentTypeId)) return 'Título da Ata'

  if (isJornal(doc)) return 'Título da matéria'
  if (isInternet(doc)) return 'Título da matéria'
  if (isLivro(doc)) return 'Nome do Livro'
  if (isCarta(doc)) return 'Assunto da Carta'
  if (isInformativo(doc)) return 'Nome do Informativo'

  return 'Assunto'
}

export const definedLabelDate = (doc) => {
  if (ataCodes.includes(doc.documentTypeId)) return 'Data da Ata'

  if (isCarta(doc)) return 'Data da Carta'
  if (isBoletim(doc)) return 'Data do Boletim'
  if (isInformativo(doc)) return 'Data do Informativo'

  return 'Data do Documento'
}

export const genUrl = ({ documentTypeName, id }, withHost = true) => {
  const docPath = `${toSlug(documentTypeName)}/${id}`
  return `${withHost ? window.location.origin : ''}/feeds/${docPath}`
}

export const toSlug = (str) => {
  const cleanedStr = String(str || '')
    .replace(/[ª/\\]/g, '-')
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .trim()

  return slugify(cleanedStr, { lower: true }).replace(/-+/g, '-')
}

const thumbStyle = {
  borderRadius: '3px',
  backgroundColor: '#027be3',
  opacity: 0.75
}

const barStyle = {
  borderRadius: '3px',
  backgroundColor: '#027be3',
  opacity: 0.2
}

const horizontalThumbStyle = Object.assign({}, thumbStyle, { height: '3px' })
const horizontalBarStyle = Object.assign({}, barStyle, { height: '5px' })
const verticalThumbStyle = Object.assign({}, thumbStyle, { width: '3px' })
const verticalBarStyle = Object.assign({}, barStyle, { width: '5px' })

export const leftBarScroll = Object.assign({}, verticalBarStyle, { left: 0 })
export const rightBarScroll = Object.assign({}, verticalBarStyle, { right: 0 })
export const topBarScroll = Object.assign({}, horizontalBarStyle, { top: 0 })
export const bottomBarScroll = Object.assign({}, horizontalBarStyle, { bottom: 0 })

export const leftThumbScroll = Object.assign({}, verticalThumbStyle, { left: 0 })
export const rightThumbScroll = Object.assign({}, verticalThumbStyle, { right: 0 })
export const topThumbScroll = Object.assign({}, horizontalThumbStyle, { top: 0 })
export const bottomThumbScroll = Object.assign({}, horizontalThumbStyle, { bottom: 0 })
